import React, { useState, useEffect, useCallback } from 'react';
import PrinciNavbar from './PrinciNavbar';
import { baseurl } from '../../url';
import './PstudentPage.css';

function StudentPage() {
  const [students, setStudents] = useState([]);
  const [alumni, setAlumni] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedAlumni, setSelectedAlumni] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedAlumniCourse, setSelectedAlumniCourse] = useState('');
  const [selectedAlumniYear, setSelectedAlumniYear] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showAlumni, setShowAlumni] = useState(false);
  const [alumniYears, setAlumniYears] = useState([]);

  const fetchStudentData = async () => {
    try {
      const response = await fetch(`${baseurl}/api/principal/student`);
      const data = await response.json();
      
      
      setStudents(data);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };

  console.log(students.map((item)=>item.photo));
  

  const fetchAlumniData = useCallback(async () => {
    try {
      const url = new URL(`${baseurl}/api/principal/alumni`);
      const params = new URLSearchParams();

      if (selectedAlumniCourse) params.append('course', selectedAlumniCourse);
      if (selectedAlumniYear) params.append('academicYear', selectedAlumniYear);
      url.search = params.toString();

      const response = await fetch(url.toString());
      const data = await response.json();
      setAlumni(data);

      const uniqueYears = [...new Set(data.map(alum => alum.academicYear))];
      setAlumniYears(uniqueYears);
    } catch (error) {
      console.error('Error fetching alumni data:', error);
    }
  }, [selectedAlumniCourse, selectedAlumniYear]);

  useEffect(() => {
    fetchStudentData();
  }, []);

  useEffect(() => {
    if (showAlumni) {
      fetchAlumniData();
    }
  }, [showAlumni, selectedAlumniCourse, selectedAlumniYear, fetchAlumniData]);

  const handleFilterChange = (setter) => (e) => setter(e.target.value);
  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const filteredStudents = students.filter(student => {
    const matchSemester = selectedSemester ? String(student.semester) === selectedSemester : true;
    const matchCourse = selectedCourse ? student.course === selectedCourse : true;
    const matchName = student.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchSemester && matchCourse && matchName;
  });

  const filteredAlumni = alumni.filter(alum =>
    alum.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDetailsClick = (student) => {
    setSelectedStudent(student);
    setSelectedAlumni(null);
  };

  const handleAlumniDetailsClick = (alum) => {
    setSelectedAlumni(alum);
    setSelectedStudent(null);
  };

  const handleDetailsClose = () => {
    setSelectedStudent(null);
    setSelectedAlumni(null);
  };

  return (
    <div>
      <PrinciNavbar />
      <div className="student-display-container">
        <div className="filter-container">
          <div className="filters">
            <input
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input"
            />

            {!showAlumni ? (
              <>
                <label htmlFor="courseSelect">Course:</label>
                <select id="courseSelect" value={selectedCourse} onChange={handleFilterChange(setSelectedCourse)}>
                  <option value="">All</option>
                  <option value="B.Tech CSE">B.Tech CSE</option>
                  <option value="B.Tech ECE">B.Tech ECE</option>
                  <option value="BBA">BBA</option>
                  <option value="BCA">BCA</option>
                  <option value="MCA">MCA</option>
                </select>

                <label htmlFor="semesterSelect">Semester:</label>
                <select id="semesterSelect" value={selectedSemester} onChange={handleFilterChange(setSelectedSemester)}>
                  <option value="">All</option>
                  {[...Array(8)].map((_, i) => (
                    <option key={i} value={i + 1}>Semester {i + 1}</option>
                  ))}
                </select>
              </>
            ) : (
              <>
                <label htmlFor="alumniCourseSelect">Course:</label>
                <select id="alumniCourseSelect" value={selectedAlumniCourse} onChange={handleFilterChange(setSelectedAlumniCourse)}>
                  <option value="">All</option>
                  <option value="B.Tech CSE">B.Tech CSE</option>
                  <option value="B.Tech ECE">B.Tech ECE</option>
                  <option value="BBA">BBA</option>
                  <option value="BCA">BCA</option>
                  <option value="MCA">MCA</option>
                </select>

                <label htmlFor="alumniYearSelect">Year:</label>
                <select id="alumniYearSelect" value={selectedAlumniYear} onChange={handleFilterChange(setSelectedAlumniYear)}>
                  <option value="">All</option>
                  {alumniYears.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </>
            )}
            <button onClick={() => setShowAlumni(prev => !prev)}>
              {showAlumni ? 'View Students' : 'View Alumni'}
            </button>
          </div>
        </div>

        {selectedStudent && (
          <div className="details-section">
            <h2>Student Details</h2>
            <p><strong>Name:</strong> {selectedStudent.name}</p>
            <p><strong>Semester:</strong> {selectedStudent.semester}</p>
            <p><strong>Course:</strong> {selectedStudent.course}</p>
            <p><strong>Phone:</strong> {selectedStudent.mobileNo}</p>
            <p><strong>Father:</strong> {selectedStudent.parentDetails?.fatherName ?? 'N/A'} ({selectedStudent.parentDetails?.fatherMobileNo ?? 'N/A'})</p>
            <p><strong>Mother:</strong> {selectedStudent.parentDetails?.motherName ?? 'N/A'} ({selectedStudent.parentDetails?.motherMobileNo ?? 'N/A'})</p>
            <p><strong>Address:</strong> {selectedStudent.address}</p>
            <button onClick={handleDetailsClose}>Close</button>
          </div>
        )}

        {selectedAlumni && (
          <div className="details-section">
            <h2>Alumni Details</h2>
            <p><strong>Name:</strong> {selectedAlumni.name}</p>
            <p><strong>Year:</strong> {selectedAlumni.academicYear}</p>
            <p><strong>Course:</strong> {selectedAlumni.course}</p>
            <p><strong>Phone:</strong> {selectedAlumni.mobileNo}</p>
            <button onClick={handleDetailsClose}>Close</button>
          </div>
        )}

        {!selectedStudent && !selectedAlumni && (
          <div>
            <h2>{showAlumni ? 'Alumni List' : 'Student List'}</h2>
            <table className="studenttable">
              <thead>
                <tr>
                  {showAlumni ? <th>Year</th> : <th>Admission No</th>}
                  <th>Image</th>
                  <th>Course</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(showAlumni ? filteredAlumni : filteredStudents).map(person => (
                  <tr key={person._id}>
                    {showAlumni
                      ? <td>{person.academicYear}</td>
                      : <td>{person.admissionNumber}</td>}
                    <td>
                      <img
src={
  person.photo && person.photo !== 'N/a' && person.photo !== 'N/A'&& person.photo !== "null"
    ? `${baseurl}/${person.photo}`
    : 'https://tse1.mm.bing.net/th?id=OIP.GHGGLYe7gDfZUzF_tElxiQHaHa&rs=1&pid=ImgDetMain'
}
alt=""
                        className="profile-img"
                      />
                    </td>
                    <td>{person.course}</td>
                    <td>{person.name}</td>
                    <td>{person.mobileNo}</td>
                    <td>
                      <button onClick={() =>
                        showAlumni
                          ? handleAlumniDetailsClick(person)
                          : handleDetailsClick(person)
                      }>
                        Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentPage;
